import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions/CarouselActions'

class ProjectCard extends React.Component{
  constructor(props){
    super(props)
  }

  render(){
    let cols = 0
    if (this.props.link!="")
       cols+=1
    if (this.props.screenshots!=false)
      cols+=1
    if (this.props.source!="")
      cols+=1

    let numOfCols = cols>1?6:12

    return(
      <div className="card large">
        <div className="card-image">
          <img src={this.props.img} />
        </div>
        <div className="card-content">
          <h5>{this.props.projectTitle}</h5>
          <p>{this.props.projectDescription}</p>
        </div>
        <div className="card-action">
          <div className="row">
          {this.props.link!=""?
            <div className={`col s${numOfCols} center-align`}>
              <a href={this.props.link} target="_blank">Link</a>
            </div>:null}
            {this.props.source!=""?
              <div className={`col s${numOfCols} center-align`}>
                <a href={this.props.source} target="_blank">Source</a>
              </div>:null}
            
            {this.props.screenshots?
              <div className={`col s${numOfCols} center-align`}>
                <a href="#!" onClick={this.props.activateCarousel.bind(this, this.props.carouselId)}>Screenshots</a>
              </div>:null}
          </div>
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch){
  return {
    activateCarousel: (carouselId)=>{dispatch(actions.showCarousel(carouselId))}
  }
}

export default connect(null, mapDispatchToProps)(ProjectCard)


// WEBPACK FOOTER //
// ./app/components/ProjectCard.js